export class TillDrawer {
  TillId: number;
  FriendlyName: string;
  COMPort: string;
  BranchUID: string;
}

export class HWCInfo {
  CustomerUId: string;        // HWC configured Customer UID
  BranchUId: string;          // HWC configured Branch UID
  HWCIPAddress: string;       // IP address of HWC
  IPAddress: string;          // IP address of client
  Version: string;            // hwc version
  HostName: string;
  WebAPIUrl: string;          // Url used by HWC to talk to WebApi
  DeviceDescription: string;  // description string of HWC - Linux or Windows
  HWCUrl: string;             // URL to access HWC
  TillDrawers: TillDrawer[] = [];  // List of Till Drawers.
  LocalModeActive: boolean=false;   // Local mode active flag

  constructor(d:any) {
    if (d)
    {
      if (d.CustomerUId) this.CustomerUId = d.CustomerUId;
      if (d.BranchUId) this.BranchUId = d.BranchUId;
      if (d.HWCIPAddress) this.HWCIPAddress = d.HWCIPAddress;
      if (d.IPAddress) this.IPAddress = d.IPAddress;
      if (d.Version) this.Version = d.Version;
      if (d.HostName) this.HostName = d.HostName;
      if (d.WebAPIUrl) this.WebAPIUrl = d.WebAPIUrl;
      if (d.DeviceDescription) this.DeviceDescription = d.DeviceDescription;
      if (d.HWCUrl) this.HWCUrl= d.HWCUrl;
      if (d.TillDrawers) this.TillDrawers= d.TillDrawers;
      if (d.LocalModeActive) this.LocalModeActive= d.LocalModeActive;      
    } 
  }

  Equals(hwcInfo: HWCInfo): boolean {
    if (this.CustomerUId != hwcInfo.CustomerUId)
      return false;
    if (this.BranchUId != hwcInfo.BranchUId)
      return false;
    if (this.HWCIPAddress != hwcInfo.HWCIPAddress)
      return false;
    if (this.IPAddress != hwcInfo.IPAddress)
      return false;
    if (this.Version != hwcInfo.Version)
      return false;
    if (this.HostName != hwcInfo.HostName)
      return false;
    if (this.WebAPIUrl != hwcInfo.WebAPIUrl)
      return false;
    if (this.HWCUrl != hwcInfo.HWCUrl)
      return false;
    if (this.DeviceDescription != hwcInfo.DeviceDescription)
      return false;
    if (this.TillDrawers.length != hwcInfo.TillDrawers.length)
      return false;
    return true;
  }
}
